var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlyhiImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04304 2.26224L16.6048 16.7144C17.1133 17.3501 16.4125 18.2359 15.6769 17.8873L4.89704 12.779C4.62908 12.652 4.45824 12.382 4.45824 12.0855V7.60629C4.45824 7.18245 4.11465 6.83885 3.6908 6.83885H1.64678C0.994701 6.83885 0.639732 6.07709 1.05914 5.5778L3.85613 2.24805C4.16762 1.87722 4.7405 1.88408 5.04304 2.26224Z",
    fill: "url(#paint0_linear_735_5880)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.807 1.57654L5.03036 11.8165C4.73562 12.2047 4.87257 12.7656 5.31301 12.9743L8.02111 14.257C8.30553 14.3918 8.64338 14.3392 8.8734 14.1244L22.2841 1.60218C22.8265 1.09575 22.4059 0.190986 21.6691 0.279254L13.3269 1.27869C13.1204 1.30343 12.9328 1.41092 12.807 1.57654Z",
    fill: "url(#paint1_linear_735_5880)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_735_5880",
    x1: 2.38828,
    y1: 3.12353,
    x2: 20.0626,
    y2: 21.2225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B03030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_735_5880",
    x1: 24.9459,
    y1: 1.3174,
    x2: 5.57313,
    y2: 13.2064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B03030"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlyhiImg);
export default __webpack_public_path__ + "static/media/flyhiImg.0b5db866297f674dfbf20f75f5b44499.svg";
export { ForwardRef as ReactComponent };